<script>
  import CheckboxItem from './checkbox-item.svelte'
  import IconButton from '@components/buttons/icon-button.svelte'
  import { CheckCheck, Trash2 } from 'lucide-svelte'

  let { label, name, group = $bindable(null), options = [], direction = "row" } = $props()
  let containerClass = $derived(direction === "column" ? "flex flex-col gap-2" : "flex flex-row gap-4")

  function selectAll() {
    group = [...options.map(option => option.value)]
  }

  function selectNone() {
    group = []
  }

  let noneSelected = $derived(group.length === 0)
  let allSelected = $derived(group.length === options.length)

  
  function handleClick(e) {
    if (!e.shiftKey) return
    if (group.length > 0 && group.length === options.length) {
      selectNone()
    } else {
      selectAll()
    }
  }
  
</script>

<div class={containerClass}>

  {#each options as option (option.value)}
    <label class="flex items-center gap-[8px]" onclick={handleClick}>
      <input type="checkbox" name={name} value={option.value} bind:group />
      <span>{option.label}</span>  
    </label>
  {/each}

  <div class="flex items-center gap-1 ml-auto">
    <IconButton class="text-gray-500" iconSize={14} Icon={CheckCheck} hint="Tout sélectionner" onclick={selectAll} disabled={allSelected} />
    <IconButton class="text-gray-500" iconSize={14} Icon={Trash2} hint="Effacer la sélection" onclick={selectNone} disabled={noneSelected} />
  </div>
  
</div>